<template>
  <div class="warning-box" :class="marginClass">
    <i class="fa-solid fa-triangle-exclamation me-2"></i>
    <span><slot>{{ message }}</slot></span>
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    default: '',
  },
  marginClass: {
    type: String,
    default: 'mb-2',
  },
});
</script>

<style scoped>
.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
  color: #856404;
  font-size: 0.8rem;
}

.warning-box i {
  color: #ffc107;
  flex-shrink: 0;
  margin-top: 0.1rem;
  font-size: 0.85rem;
}
</style>
